import { Props as FooterProps } from 'app/components/Common/Footer'
import { FooterDataQuery } from 'graphql-types'
import { compact } from 'lodash'

export const getFooterProps = (
  data: FooterDataQuery,
  languageCode: string,
): FooterProps | undefined => {
  const company = data.cms.company
  const address =
    `${company?.address} - ${company?.postal_code} ${company?.locality} ${company?.region} ${company?.country}` ||
    undefined
  const email = company?.email || undefined
  const IBEID = company?.ibeid || undefined
  const logo = compact(data.logo.nodes)[0].publicURL || undefined
  const phone = company?.phone || undefined
  const siteName = data.site?.siteMetadata?.title || undefined
  const vat = company?.vat || undefined

  return {
    address,
    email,
    IBEID,
    languageCode,
    logo,
    phone,
    siteName,
    vat,
  }
}
